<template>
  <div id="partners">
    <app-navbar></app-navbar>
    <div class="container padding-top">
      <div class="partnersBlock">
        <div
          v-if="page"
          class="partners-intro text-center"
          v-html="introHtml"
        ></div>

        <template v-for="(section, sIndex) in sections">
          <!-- Skupinový režim: jeden nadpis nad mřížkou log -->
          <template v-if="section.displayMode !== 'INDIVIDUAL'">
            <p
              v-if="section.title"
              :key="'title-' + section.id"
              class="section-title text-center"
            >
              {{ section.title | translation }}
            </p>
            <div
              :key="'row-' + section.id"
              class="row partner-row text-center align-items-center justify-content-center"
            >
              <div
                v-for="logo in section.logos"
                :key="logo.id"
                :class="[section.colClass, 'partner-tile']"
              >
                <a
                  v-if="logo.url"
                  :href="logo.url"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="partner-link"
                >
                  <img
                    class="img-fluid"
                    :width="logoWidth(logo)"
                    :src="logoSrc(logo)"
                    :alt="logo.alt"
                    :loading="sIndex === 0 ? null : 'lazy'"
                    decoding="async"
                  />
                </a>
                <img
                  v-else
                  class="img-fluid"
                  :width="logoWidth(logo)"
                  :src="logoSrc(logo)"
                  :alt="logo.alt"
                  :loading="sIndex === 0 ? null : 'lazy'"
                  decoding="async"
                />
              </div>
            </div>
          </template>

          <!-- Individuální režim: každé logo má vlastní nadpis ve sloupci -->
          <div
            v-else
            :key="'row-' + section.id"
            class="row partner-row text-center align-items-start justify-content-center"
          >
            <div
              v-for="logo in section.logos"
              :key="logo.id"
              :class="[section.colClass, 'partner-section']"
            >
              <p v-if="logo.title" class="section-title">
                {{ logo.title | translation }}
              </p>
              <div class="partner-tile">
                <a
                  v-if="logo.url"
                  :href="logo.url"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="partner-link"
                >
                  <img
                    class="img-fluid"
                    :width="logoWidth(logo)"
                    :src="logoSrc(logo)"
                    :alt="logo.alt"
                    :loading="sIndex === 0 ? null : 'lazy'"
                    decoding="async"
                  />
                </a>
                <img
                  v-else
                  class="img-fluid"
                  :width="logoWidth(logo)"
                  :src="logoSrc(logo)"
                  :alt="logo.alt"
                  :loading="sIndex === 0 ? null : 'lazy'"
                  decoding="async"
                />
              </div>
            </div>
          </div>
        </template>

        <h2 v-if="page" class="text-center pt-lg-4 pt-4 pb-lg-4">
          {{ page.subtitle | translation }}
        </h2>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import footer from "@/components/base/footer";
import navbar from "@/components/base/navbar";
import axios from "@/api/axiom-instance";
import config from "@/config";

export default {
  name: "sponsors",
  components: {
    "app-navbar": navbar,
    "app-footer": footer,
  },
  data() {
    return {
      page: null,
      sections: [],
    };
  },
  computed: {
    introHtml: function () {
      if (!this.page) return "";
      const html = this.$options.filters.translation(this.page.intro);
      return html != null ? html : "";
    },
  },
  created() {
    this.load();
  },
  methods: {
    load: function () {
      // Krátký timeout a žádné přesměrování: stránka se zobrazí i kdyby API
      // bylo pomalé/nedostupné (jen bez obsahu), nikdy neodbalí uživatele jinam.
      axios
        .get("/sponsors/content", { timeout: 8000 })
        .then((success) => {
          this.page = success.data.page || null;
          this.sections = success.data.sections || [];
        })
        .catch(() => {
          // ponecháme prázdný shell
        });
    },
    logoSrc: function (logo) {
      return (
        config.API_URL +
        "/sponsor-image?id=" +
        logo.id +
        "&v=" +
        (logo.updated || 0)
      );
    },
    logoWidth: function (logo) {
      return logo.widthPercent != null ? logo.widthPercent + "%" : null;
    },
  },
};
</script>

<style scoped>
h2 {
  color: black;
  font-size: 2.5em;
  font-family: "Transcript Pro";
}

.padding-top {
  padding-top: 8rem;
}

p {
  font-family: "Transcript Mono";
  color: #4c4d4f;
}

#partners {
  background-color: #ffbe46;
}

.partnersBlock {
  background-color: white;
  margin-bottom: 3em;
  padding: 4em 2em 0;
}

.partners-intro {
  max-width: 960px;
  margin: 0 auto 3rem;
}

/* Úvodní text se vykresluje přes v-html, takže odstavce nedostanou scoped
   atribut komponenty - stylujeme je deep selektorem (shodně s původním p). */
.partners-intro >>> p {
  font-family: "Transcript Mono";
  color: #4c4d4f;
  margin-bottom: 1.25rem;
}

.section-title {
  margin: 0;
  padding-top: 1.5rem;
}

.partner-row {
  padding-top: 1rem;
  padding-bottom: 2rem;
}

.partner-section .partner-tile {
  min-height: 180px;
}

.partner-tile {
  min-height: 160px;
  padding: 1.5rem 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.partner-link {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 991.98px) {
  .partnersBlock {
    padding-right: 1em;
    padding-left: 1em;
  }

  .partner-section .partner-tile,
  .partner-tile {
    min-height: auto;
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
}
</style>
